import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Persona = 'agent' | 'admin' | 'super';

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: string;
  // RBAC דינמי: רשימת "screen.action" אפקטיבית + מידע התפקיד. חסר (סשן
  // ישן / mock) ⇒ מתנהגים כ"הכל מותר" כדי לא לנעול אף אחד — השרת אוכף ממילא.
  permissions?: string[];
  role_info?: { slug: string; name: string; persona: 'admin' | 'agent' };
  is_super_admin: boolean;
  tenant_id: number | null;
  locale: 'he' | 'en';
}

export interface AuthTenant {
  id: number;
  slug: string;
  name: string;
  status: string;
  /** האם פורטל ההקלטות הציבורי דלוק לדייר (כבוי כברירת מחדל). */
  recordings_portal?: boolean;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  tenant: AuthTenant | null;
  tenantSlug: string | null;
  persona: Persona | null;
  set: (data: {
    token: string;
    user: AuthUser;
    persona: Persona;
    tenant?: AuthTenant | null;
  }) => void;
  setTenant: (tenant: AuthTenant | null) => void;
  setTenantSlug: (slug: string | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      tenant: null,
      tenantSlug: null,
      persona: null,
      set: ({ token, user, persona, tenant }) =>
        set({
          token,
          user,
          persona,
          tenant: tenant ?? null,
          tenantSlug: tenant?.slug ?? null,
        }),
      setTenant: (tenant) => set({ tenant, tenantSlug: tenant?.slug ?? null }),
      setTenantSlug: (tenantSlug) => set({ tenantSlug }),
      clear: () => set({ token: null, user: null, tenant: null, tenantSlug: null, persona: null }),
    }),
    {
      name: 'merkaziya-auth',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        tenant: state.tenant,
        tenantSlug: state.tenantSlug,
        persona: state.persona,
      }),
    }
  )
);
